import { Form } from './form';
import { Config } from '../config';
import { QuantityForm } from './quantity-form';
import { FormTypes } from './form-types';
import { Order } from '../config/order';
import { Product } from '../config/product';
import { QuantityValidator } from '../validators/quantity-validator';
import { ProductType } from '../config/product-type';
import { SubscriptionView } from '../view/subscription-view';
import { Price } from '../config/price';

export class AdaptiveSubscriptionPricesForm extends Form {

    private products: Product[] = [];
    currentSubscription: any = {};
    quantityForm: QuantityForm = new QuantityForm();
    quantity = 1;
    type = FormTypes.AdaptiveSubscriptionPrices;
    view: SubscriptionView = new SubscriptionView();


    init = async (config: Config, callbacks: any) => {
        await super.init(config, callbacks);

        if (this.config.products) {
            this.products = this.config.products.filter((product: Product) => {
                return (product.type === ProductType.SUBSCRIPTION && product.subscriptionPrices && !product.addon);
            });

            this.currentSubscription = this.products[0] || {};
        }
        if (this.products.every((product) => product.showQuantity)) {
            await this.quantityForm.init({}, {
                setQuantity: this.setQuantity.bind(this)
            });
            this.validators.push(new QuantityValidator());
        }

        return Promise.resolve();
    }

    render = async () => {
        this.view.setConfig(this.config);
        if (this.products.length > 1) {
            this.view.renderMultipleProducts(this.products, this.onSelectedSubChange.bind(this));
        }

        this.currentSubscription = this.products[0] || {};
        this.paymentData.amount = this.currentSubscription.amount || 0;
        this.paymentData.type = this.currentSubscription.type;
      
        if (this.products.every((product) => product.showQuantity)) {
            const quantityElementId = 'adaptive_subscription_prices';
            this.validationContext = { id: quantityElementId };
            await this.quantityForm.render(quantityElementId, this.currentSubscription.name);
        }

        this.setQuantity();
        return Promise.resolve();
    }

    onSelectedSubChange(selectedProduct: any) {
        this.currentSubscription = this.products.find((product) => product.name === selectedProduct.name);
        // this.paymentData.amount = +selectedProduct.value * this.quantity;
        if (this.quantityForm.setProductName) {
            this.quantityForm.setProductName(this.currentSubscription.name);
        }

        this.paymentData.type = this.currentSubscription.type;

        this.quantityForm.resetQuantity();
        this.quantityForm.quantity = 1;
        this.setQuantity();
    }


    setAmount = async () => {
        const currentSubscriptionPrice = this.getCurrentSubscriptionPrice();
        this.currentSubscription.subscriptionPlanId = currentSubscriptionPrice.planId;
        const amount = currentSubscriptionPrice.amount;
        this.currentSubscription.amount = amount;
        this.paymentData.amount = amount;
        if (this.currentSubscription.showQuantity) {
            await this.quantityForm.init({}, {
                setQuantity: this.setQuantity.bind(this)
            });
            this.validators.push(new QuantityValidator());
        }
    }

    getCurrentSubscriptionPrice = () => {
        if(this.currentSubscription.subscriptionPrices[0].endDate === '' || this.currentSubscription.subscriptionPrices[0].endDate){
            return this.getDateBasedPricing();
        }

        if(this.currentSubscription.subscriptionPrices[0].upToQuantity){
            return this.getQuantityBasedPricing(this.quantity);
        }
    }

    setQuantity() {
        if (this.quantityForm.quantity !== 0) {
            this.quantity = this.quantityForm.quantity;
        } else {
            this.quantity = 1;
        }
        this.setAmount();
        this.paymentData.amount = this.quantity * this.currentSubscription.amount;
        this.triggerEvent('amountChange');
    }

    getSelectedProducts() {
        return [ this.currentSubscription ];
    }

    getQuantityBasedPricing(quantity: number) {
        const currentPrice = this.currentSubscription.subscriptionPrices.sort((a:Price, b:Price) => {
            return a.upToQuantity - b.upToQuantity;
        }).find((price: Price) => {
            return price.upToQuantity >= quantity;
        });

        return currentPrice;
    }

    getDateBasedPricing(): Price {
        const timeNow = Date.now();
        const subscriptionPrices = this.currentSubscription.subscriptionPrices.filter((subscriptionPrice: any) => {
            return Date.parse(subscriptionPrice.endDate) > timeNow;
        });
        if (subscriptionPrices.length === 0) {
            return this.currentSubscription.subscriptionPrices.find((subscriptionPrice: any) => subscriptionPrice.endDate === '');
        }

        const currentSubscriptionPrice = subscriptionPrices.find((subscriptionPrice: any) => {
            const endDates = subscriptionPrices.map((item: any) => Date.parse(item.endDate));
            return Date.parse(subscriptionPrice.endDate) === Math.min.apply(null, endDates);
        });
        return currentSubscriptionPrice;
    }

    submit(order: Order) {
        if (this.currentSubscription.showQuantity) {
            this.currentSubscription.quantity = this.quantity;
        }
        order.selectedProducts.push(this.currentSubscription);
        return Promise.resolve(order);
    }
    
}
